import { showToast } from "@teamna/ui/components/index.ts";
import { isApiError } from "@teamna/web-client/api/client.ts";
import { useRunsOnTeamna, useSetRunsOnTeamna } from "../lib/cc-api.ts";
import { SwitchCard } from "./switch-card.tsx";

/**
 * The "Runs on Teamna" link of one business (website traffic plan, task 2.1). Parents see a small
 * link to the Teamna site on the join page, the payment page, the receipt and the booking emails.
 *
 * Teamna staff turn it off for one business here. The owner has no switch in Desk. A business with
 * a branded app never shows the link, so the switch is locked for it. Each change writes an audit
 * row with the staff email; it changes one business only, so there is no confirm step.
 */
export function RunsOnTeamnaCard({ businessId }: { businessId: string }) {
  const state = useRunsOnTeamna(businessId);
  const setLink = useSetRunsOnTeamna(businessId);

  const change = (on: boolean) =>
    setLink.mutate(on, {
      onSuccess: (data) => showToast(data.on ? "Parents see the \"Runs on Teamna\" link." : "The \"Runs on Teamna\" link is off for this business."),
      onError: (error) => showToast(isApiError(error) && error.detail ? error.detail : "The link did not change. Try again."),
    });

  return (
    <SwitchCard
      id="runs-on-teamna-heading"
      title="Parent pages"
      loadingLabel="Loading the link setting"
      state={state}
      pending={setLink.isPending}
      onChange={change}
      row={({ on, brandedApp }) => ({
        label: '"Runs on Teamna" link for parents',
        hint: brandedApp
          ? "Off. This business has a branded app, so parents never see Teamna links."
          : on
            ? "On. Parents see a small \"Runs on Teamna\" link on the join page, the payment page, the receipt and the booking emails."
            : "Off. Parents see no \"Runs on Teamna\" link. The Privacy and Terms links stay.",
        checked: on && !brandedApp,
        disabled: brandedApp,
      })}
    />
  );
}
